import React from "react";
import { Link } from "react-router-dom";

export const LoginForm = ({
  handleChange,
  handleSubmit,
  loading,
  contrastColorPrimary,
  credentials,
  theme,
  lang,
}) => {
/*   React.useEffect(() => {
    console.log(lang);
  }, [lang]); */
  return (
    <form
      onSubmit={handleSubmit}
      action="https://par.tuclase.cl/login/index.php"
      method="post"
    >
      <div className="col-md-12">
        <div>
          <p
            className="iniciar-new"
            style={{
              color: contrastColorPrimary,
            }}
          >
            Iniciar Sesión
          </p>
        </div>
        <input
          onChange={handleChange}
          type="text"
          name="username"
          className="form-control box-ingreso2"
          placeholder={(lang && lang.Login.username) ?? ""}
          value={credentials.username}
        />
      </div>
      <div className="col-md-12 mt-4">
        <input
          onChange={handleChange}
          type="password"
          name="password"
          className="form-control box-ingreso2"
          placeholder={(lang && lang.Login.password) ?? ""}
          value={credentials.password}
        />
      </div>
      <div className="col-md-12">
        <button
          type="submit"
          className="btn btn-primary btn-lg btn-block bot-text h-[5rem] hover:brightness-110 transition-all "
          style={{
            backgroundColor: theme.colors.tertiary_dark,
            color: theme.colors.text_login_light,
          }}
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-md mx-3"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            <>{(lang && lang.Login.send) ?? ""}</>
          )}
        </button>
      </div>
      {/* <div className="col-md-12">
        <p className="cuenta">
          <Link to="/login/forgot_password">
            {(lang && lang.Login.recovery) ?? ""}
          </Link>
        </p>
      </div> */}
    </form>
  );
};
